/**
 * User-facing message from a JSON error body (fetch or axios).
 * Supports legacy `{ error: "..." }` and v2 `{ success: false, error: { message } }`.
 */
export function messageFromErrorBody(data, fallback = 'Something went wrong') {
  if (!data) return fallback;
  if (typeof data === 'string') return data;
  if (data.success === false && data.error && (data.error.message || data.error.code)) {
    return data.error.message || data.error.code || fallback;
  }
  if (data.error && typeof data.error === 'string') return data.error;
  return data.message || fallback;
}

/** Parse a failed fetch Response and return a user-facing error message. */
export async function messageFromFetchResponse(response, fallback = 'Request failed') {
  const errData = await response.json().catch(() => ({}));
  return messageFromErrorBody(errData, fallback);
}
